<template>
  <div class="divide-y divide-secondary flex flex-wrap">
    <div
      v-for="i in randomRows"
      :key="`i${i}`"
      class="bg-white shadow overflow-hidden sm:rounded-lg m-4 w-96 h-64"
    >
      <div
        v-for="j in n"
        :key="`j${j}`"
        :class="['linear-background flex m-6 h-3 rounded-full', randomWidth()]"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    randomWidth() {
      const min = 1
      const max = 2
      return `w-1/${Math.floor(Math.random() * (max - min + 1)) + min}`
    },
  },
  computed: {
    randomRows() {
      return Math.floor(Math.random() * (Math.floor(10) - Math.ceil(4))) + Math.ceil(3)
    },
  },
  props: {
    n: Number,
  },
}
</script>

<style scoped>
@keyframes placeHolderShimmer {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
}
.linear-background {
  @apply bg-secondary;

  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: linear-gradient(to right, #edf2f7 8%, #f6f7f8 18%, #edf2f7 33%);
  background-size: 500px 10px;
  position: relative;
  overflow: hidden;
}
</style>
